var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h2',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]),_c('SubMenu'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }